import { ComponentPropsWithoutRef } from 'react';

export default function ETHFilledSquare(
  props: ComponentPropsWithoutRef<'svg'>,
) {
  return (
    <svg viewBox="0 0 20 20" {...props}>
      <circle fill="#5A7FF2" cx="10" cy="10" r="10" />
      <polygon fill="rgba(255,255,255,0.6)" points="10.3,2.5 10.3,8 15,10.1 " />
      <polygon fill="#ffffff" points="10.3,2.5 5.6,10.1 10.3,8 " />
      <polygon
        fill="rgba(255,255,255,0.6)"
        points="10.3,13.7 10.3,17.5 15,11 "
      />
      <polygon fill="#ffffff" points="10.3,17.5 10.3,13.7 5.6,11 " />
      <polygon
        fill="rgba(255,255,255,0.2)"
        points="10.3,12.9 15,10.1 10.3,8 "
      />
      <polygon
        fill="rgba(255,255,255,0.6)"
        points="5.6,10.1 10.3,12.9 10.3,8 "
      />
    </svg>
  );
}
